// Actions
export const SEARCH: string = "Search/SEARCH";

export const SEARCH_REQUEST: string = "Search/SEARCH_REQUEST";
export const SEARCH_SUCCESS: string = "Search/SEARCH_SUCCESS";
export const SEARCH_FAILURE: string = "Search/SEARCH_FAILURE";
